import apiClient from '../../core/apiClient';
import { endpoints } from '../../core/endpoints';
import type {
  User,
  GetUsersParams,
  CreateUserDto,
  UpdateUserDto,
} from './users.types';

const BASE = endpoints.auth.users;
const EXPORT = endpoints.auth.exportUsers;

export const getUsers = (params?: GetUsersParams, signal?: AbortSignal): Promise<User[]> =>
  apiClient.get<User[]>(BASE, params, { signal });

export const getUserById = (id: string): Promise<User> =>
  apiClient.get<User>(`${BASE}/${id}`);

export const createUser = (data: CreateUserDto): Promise<User> =>
  apiClient.post<User>(BASE, data);

export const updateUser = (id: string, data: UpdateUserDto): Promise<User> =>
  apiClient.put<User>(`${BASE}/${id}`, data);

export const deleteUser = (id: string): Promise<void> =>
  apiClient.delete<void>(`${BASE}/${id}`);

export const exportUsers = (criteria?: Record<string, unknown>): Promise<Blob> =>
  apiClient.download(EXPORT, criteria);
